export default {
  items: [
    {
      name: 'Inicio',
      url: '/inicio',
      icon: 'icon-home',
      global: true
    },
    {
      name: 'Editor',
      url: '/editor',
      icon: 'icon-speedometer',
      authenticated: true
    },
    // {
    //   name: 'Usuarios',
    //   url: '/usuarios',
    //   icon: 'icon-people',
    //   authenticated: true,
    //   allowed_users: true
    // },
    {
      name: 'Comunidad',
      url: '/comunidad',
      icon: 'icon-people',
      authenticated: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js